<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const GameShowsIcon = getIcon("GameShowsIcon");
</script>

{#if typeof GameShowsIcon === 'string'}
	<img src={GameShowsIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof GameShowsIcon === 'function'}
	<svelte:component this={GameShowsIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
